import React, { useEffect, useState } from 'react';
import TableView from './TableView';
import icBrodccast from '../../assets/svg/broadcasts/card-icon/card.svg';
import icPreview from '../../assets/svg/broadcasts/ic-pagination/preview.svg';
import icNext from '../../assets/svg/broadcasts/ic-pagination/next.svg';
import icBtnVeiw from '../../assets/svg/btn/eye.svg';
import btnCheck from '../../assets/svg/btn/icCheck.svg';
import btnEdit from '../../assets/svg/btn/edit-outline.svg';
import icDownload from '../../assets/svg/btn/download.svg';
import icViewsCounter from '../../assets/svg/btn/ic-view-bg-white.svg';
import axiosClient from '../../../axios-client';
import { Helmet } from 'react-helmet';

const AllBroadcasts = () => {
    const [broadcastData, setBroadcastData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState();
    const [ metTitle, setMetaTitle ] = useState('');
    const [ metaDescription, setMetaDescription ] = useState('');

    useEffect(() => {
        fetchData();
        appSettings();
    }, [ currentPage ]);
    
    const appSettings = () => {
      axiosClient.get('/app-settings')
        .then(({ data }) => {
            setMetaTitle(data.data.title)
            setMetaDescription(data.data.description);
          })
          .catch(() => {
              setLoading(false)
          })
    }
      

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axiosClient.get(`/broadcasts?page=${currentPage}`);
            const responseData = response.data.data;

            if (responseData && responseData.broadcasts && Array.isArray(responseData.broadcasts)) {
                setBroadcastData(responseData.broadcasts);
                setTotalPages(responseData.pagination.total_pages);
                setLoading(false);
            } else {
                console.error('Broadcasts data is not in the expected format:', responseData);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error fetching data:', error);
        }
    };

    const handlePrevPage = () => {
        setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        setCurrentPage(currentPage + 1);
    };

    const data = broadcastData.map(item => ({
        date: item.sent_at,
        title: item.name || '-',
        store: item.name || '-',
        contact: item.contacts || '-',
        lang: item.language || '-',
        template: item.template || '-',
        whatsapp: item.whatsapp_area || '-',
        // whatsapp: item.stop_notifications || '0',
        confirms: item.confirmations,
        classSentTxt: item.is_draft ? 'txt-warning' : 'txt-success',
        isSent: item.is_draft ? '' : `${btnCheck}`,
        sent: item.is_draft ? 'Draft' : 'Sent',
        btnVeiw: `${icBtnVeiw}`,
        classBtnView: item.is_draft ? 'd-none' : 'd-flex',
        classBtnDownload: item.is_draft ? 'd-none' : 'd-flex',
        download: `${icDownload}`,
        classConfirms: 'bg-btn-confirm text-white d-inline-flex',
        icDownload: `${icViewsCounter}`,
        icDownloadClass: 'd-flex ms-auto',
        classBtnEdit: item.is_draft ? 'd-flex' : 'd-none',
        btnEdit: `${btnEdit}`
    }));

    return (
        <>
            <Helmet>
                <title>All Broadcasts | {metTitle}</title>
                <meta name="description" content={metaDescription}/>
                <meta name="keywords" content="WhatsApp Business, Customer Service, Automations, Broadcasts, AI Chatbots, Lead Qualification" />
            </Helmet>
            <div className='my-5'>
                <div className='container-fluid justify-content-center'>
                    <div className='justify-content-center p-0 m-0'>
                        <div className='card rounded-25 bg-white border justify-content-center align-items-center'>
                            <img width={52} height={52} className='ic-card mx-auto' src={icBrodccast} alt='Broadcast Icon' />
                            <h1 className='text-center title my-3'>All Broadcasts</h1>
                            <div className='divider my-4'></div>
                            {/* <TableView data={data} /> */}
                            {!loading ? <div className='w-100 justify-content-center'>
                                {data ? <div className='table-responsive mt-3'>
                                    <TableView data={data} />
                                </div> : <p className="text-center my-3">There is currently no information to display.</p>}
                            </div> : <p className='my-3 text-center'>Loading..</p>}
                        </div>
                    </div>
                    {/* <nav aria-label="Page navigation">
                        <ul className="pagination justify-content-center align-items-center my-5">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button className="mx-2 justify-content-center align-items-center d-flex rounded-circle page-link mx-1" onClick={handlePrevPage} disabled={currentPage === 1}>
                                    <img src={icPreview} alt='Previous' />
                                </button>
                            </li>
                            {Array.from({ length: Math.min(totalPages, 4) }, (_, index) => index + 1).map(page => (
                                <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                    <button className={`${currentPage === page ? 'active' : ''} justify-content-center align-items-center d-flex rounded-circle page-link mx-1`} onClick={() => setCurrentPage(page)}>{page}</button>
                                </li>
                            ))}
                            {totalPages > 4 && (
                                <li className="page-item">
                                    <button className="justify-content-center align-items-center d-flex rounded-circle page-link mx-1" onClick={() => setCurrentPage(Math.min(currentPage + 4, totalPages))}><span className='pb-2'>...</span></button>
                                </li>
                            )}
                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <button className="mx-2 justify-content-center align-items-center d-flex rounded-circle page-link mx-1" onClick={handleNextPage} disabled={currentPage === totalPages}>
                                    <img src={icNext} alt='Next' />
                                </button>
                            </li>
                        </ul>
                    </nav> */}

                    {totalPages > 1 && (
                        <nav aria-label="Page navigation">
                            <ul className="pagination justify-content-center align-items-center my-5">
                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button className="mx-2 justify-content-center align-items-center d-flex rounded-circle page-link mx-1" onClick={handlePrevPage} disabled={currentPage === 1}>
                                        <img src={icPreview} alt='Previous' />
                                    </button>
                                </li>
                                {Array.from({ length: Math.min(totalPages, 4) }, (_, index) => currentPage + index - (currentPage === 1 ? 0 : 1)).map(page => (
                                    <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                        <button className={`${currentPage === page ? 'active' : ''} justify-content-center align-items-center d-flex rounded-circle page-link mx-1`} onClick={() => setCurrentPage(page)}>{page}</button>
                                    </li>
                                ))}
                                {totalPages > 4 && (
                                    <li className="page-item">
                                        <button className="justify-content-center align-items-center d-flex rounded-circle page-link mx-1" onClick={() => setCurrentPage(Math.min(currentPage + 4, totalPages))}><span className='pb-2'>...</span></button>
                                    </li>
                                )}
                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                    <button className="mx-2 justify-content-center align-items-center d-flex rounded-circle page-link mx-1" onClick={handleNextPage} disabled={currentPage === totalPages}>
                                        <img src={icNext} alt='Next' />
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    )}





                </div>
            </div>
        </>
    );
}

export default AllBroadcasts